<template>
  <main>
    <mdb-container class="text-center pentagon-not-found">
      <h1>{{ $t('not_found.heading') }}</h1>
      <p>{{ $t('not_found.message') }}</p>
      <p><router-link to="/">{{ $t('not_found.home_link') }}</router-link></p>
    </mdb-container>
  </main>
</template>

<script>
import { mdbContainer } from 'mdbvue';

export default {
  name: 'NotFound',
  components: {
    mdbContainer,
  },
  created() {
    this.$store.commit('TOGGLE_OFF_NAVBAR_TRANSPARENT');
  },
};
</script>
